import { EntityScreenRow } from 'app/models/entity-screen-row';
import { KpiProps } from 'app/views/components/KPI/KPI';
import { useKPIFilters } from 'app/views/components/KPI/KPI-filters';
import { useEffect } from 'react';

export const getKPIData = (
  data: EntityScreenRow[],
  setData: React.Dispatch<React.SetStateAction<EntityScreenRow[]>>
): KpiProps[] => {

  const filterFunctions: Record<string, (ent: EntityScreenRow) => boolean> = {
    'Unvalidated Tax Form': (ent: EntityScreenRow) => ent.taxFormStatus !== 'Validated',
    'Inactive': (ent: EntityScreenRow) => ent.status === 'Inactive',
    'Active': (ent: EntityScreenRow) => ent.status === 'Active',
    'Pending KYC': (ent: EntityScreenRow) => ent.kycStatus === 'PendingKycStatus',
  };

  const { applyFilter, appliedFilters } = useKPIFilters({ data, filterFunctions, setData });

  useEffect(() => {
    if (appliedFilters.size === 0) return;
    applyFilter(null);
  }, [data]);


  if (!data) return [];

  const allEntities = data;
  const validatedEnts = data.filter(ent => ent.taxFormStatus !== 'Validated');
  const inactiveEnts = data.filter(ent => ent.status === 'Inactive');
  const activeEnts = data.filter(ent => ent.status === 'Active');
  const pendingKYCEnts = data.filter(ent => ent.kycStatus === 'PendingKycStatus');

  return [
    {
      title: 'All Entities',
      amount: allEntities.length,
      activeFilter: appliedFilters.size === 0,
      event: () => applyFilter('All Entities')
    },
    {
      title: 'Unvalidated Tax Form',
      amount: validatedEnts.length,
      activeFilter: appliedFilters.has('Unvalidated Tax Form'),
      event: () => applyFilter('Unvalidated Tax Form')
    },
    {
      title: 'Inactive',
      amount: inactiveEnts.length,
      activeFilter: appliedFilters.has('Inactive'),
      event: () => applyFilter('Inactive')
    },
    {
      title: 'Active',
      amount: activeEnts.length,
      activeFilter: appliedFilters.has('Active'),
      event: () => applyFilter('Active')
    },
    {
      title: 'Pending KYC',
      amount: pendingKYCEnts.length,
      activeFilter: appliedFilters.has('Pending KYC'),
      event: () => applyFilter('Pending KYC'),
    },
  ];
};
